import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UiStateService {
  readonly showCancelButton = signal(true);

  setShowCancelButton(value: boolean): void {
    this.showCancelButton.set(value);
  }
}
